import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  text: {
    padding: '5px 10px',
    borderRadius: 20,
    color: theme.palette.error.contrastText,
    width: 'fit-content',
    display: 'flex',
    '& svg': {
      fontSize: 22,
      verticalAlign: 'text-top',
      marginLeft: 5
    }
  },
  red: {
    backgroundColor: theme.palette.error.main
  },
  yellow: {
    backgroundColor: theme.palette.warning.main
  },
  lightYellow: {
    backgroundColor: theme.palette.warning.light
  },
  green: {
    backgroundColor: theme.palette.success.main
  },
  lightGreen: {
    backgroundColor: theme.palette.success.light
  },
  blue: {
    backgroundColor: theme.palette.info.main
  },
  lightBlue: {
    backgroundColor: theme.palette.info.light
  },
  grey: {
    backgroundColor: theme.palette.grey[500]
  },
  lightGrey: {
    backgroundColor: theme.palette.grey[300]
  },
  isLong: {
    fontSize: 13,
    display: 'flex',
    alignItems: 'flex-end'
  }
}))

export default useStyles
